import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/sample/products/')({
  component: () => (
    <div>
      <h1 style={{ marginBottom: '10px', color: '#333', fontSize: '1.5rem' }}>
        Products Index
      </h1>
      <p style={{ color: '#666', fontSize: '14px' }}>
        Products 레이아웃 내부에서 렌더링되는 기본 인덱스 페이지입니다.
      </p>
    </div>
  ),
});
